import {
  OfferPricingType,
  PercentageType,
} from 'src/common/apollo/types/swarmx/graphql'
import { DotcEnums } from 'src/common/contracts/enums/dotc'
import { Order } from 'src/common/contracts/hooks/dotc/useTakeOffer/types'
import { OfferWithTake } from './findBestOffers'
import { isBlockOffer } from '.'
import { ZERO } from '../big-utils'
import { AssetHelper } from './assetHelper'

export const offersToOrders = (offers: OfferWithTake[]): Order[] => {
  return offers.map<Order>(offer => ({
    offer,
    offerId: offer.id,
    offerPricingType:
      offer.offerPrice.pricingType === OfferPricingType.FixedPricing
        ? DotcEnums.OfferPricingType.FixedPricing
        : DotcEnums.OfferPricingType.DynamicPricing,
    amountPaid:
      isBlockOffer(offer) &&
      offer.offerPrice.pricingType === OfferPricingType.DynamicPricing
        ? ZERO
        : offer.toTake,
    maximumDepositToWithdrawalRate: offer.depositToWithdrawalRate
      ? AssetHelper.calcRateWithPercentage(
          offer.depositToWithdrawalRate,
          500n, // 5%
          PercentageType.Plus
        )
      : 0n,
    ...(offer.depositAsset.type !== 'ERC20' && {
      // Required for ERC1155, ERC721
      tokenId: offer.depositAsset.tokenId,
      amountToWithdraw: offer.availableAmount,
    }),
  }))
}
